export const OK = "باشه";
export const ACCEPT = "قبول";
export const REJECT = "رد درخواست";
export const VIEW_ANS = "مشاهده پاسخ";
export const CHANGE_CHEQUE_STATUS = "تغییر وضعیت چک";
export const MORE_INFO = "اطلاعات بیشتر";